import { PERK_TYPES } from './constants';
import { Perk } from './types';

type TrackingEvent =
  | 'view_promotion'
  | 'unlock_promotion'
  | 'redeem_promotion'
  | 'select_promotion';
type PerkActionType = 'view' | 'unlock' | 'redeem' | 'apply';

export const sendTrackingEvent = (
  event: TrackingEvent,
  perk: Perk,
  actionType: PerkActionType,
) => {
  window.dataLayer = window.dataLayer || [];

  if (window.dataLayer) {
    window.dataLayer.push({
      ecommerce: null,
      perk_action_type: null,
    });

    window.dataLayer.push({
      event,
      ecommerce: {
        items: [
          {
            promotion_id: perk.id,
            promotion_name: perk.name,
            creative_name: perk.partner_name ?? 'Yummy Bros',
            creative_slot: [
              PERK_TYPES.INTERNAL_GENERIC,
              PERK_TYPES.INTERNAL_UNIQUE,
            ].includes(perk.type)
              ? 'internal'
              : 'partner',
          },
        ],
      },
      perk_action_type: actionType,
    });
  }
};
